import React from 'react';
import PropTypes from 'prop-types';
import { badges as Badges } from '@breezeway/brzw-components';

import { taskHelper } from '../../../utils';

const { TASK_ASSIGNMENT_STATUS } = taskHelper;

const getStatusCode = code => {
  switch (code) {
    case TASK_ASSIGNMENT_STATUS.ACCEPTED:
      return Badges.constants.BADGE_THEMES.SUCCESS;
    case TASK_ASSIGNMENT_STATUS.PENDING:
    case TASK_ASSIGNMENT_STATUS.DECLINED:
      return Badges.constants.BADGE_THEMES.WARNING;
    case TASK_ASSIGNMENT_STATUS.EXPIRED:
      return Badges.constants.BADGE_THEMES.ERROR;
    default:
    case TASK_ASSIGNMENT_STATUS.ASSIGNED:
      return Badges.constants.BADGE_THEMES.PRIMARY;
  }
};

const AssignmentBadge = ({ status: { code, name } }) => {
  if (!code) {
    return null;
  }

  return (
    <Badges.Badge
      size={Badges.constants.BADGE_SIZES.SHORT}
      text={name}
      theme={getStatusCode(code)}
    />
  );
};

AssignmentBadge.propTypes = {
  status: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default AssignmentBadge;
